export const OUTER_STATE = 'OUTER_STATE';
export const SENTENCE_STATE = 'SENTENCE_STATE';
export const SUBJECT_STATE = 'SUBJECT_STATE';
export const ARRAY_STATE = 'ARRAY_STATE';
export const CHANGE_PAGE = 'CHANGE_PAGE';
